import React from 'react';
import { PropInfo, CodeExample, RobotProps } from '@cimpress/react-components';

import RobotCode from '!raw-loader!./robot.jsx';
import RobotDemo from './robot.jsx';
import ComponentDoc from '../../shared/TabbedComponentDoc';

const RobotDocs = () => {
  const propInfos: PropInfo<RobotProps>[] = [
    {
      name: 'size',
      type: 'string',
      default: 'sm',
      description: (
        <span>
          Sets the size of the robot. One of <code>sm</code> or <code>lg</code>. Use the larger robot only for full-page
          messages.
        </span>
      ),
    },
    {
      name: 'status',
      type: 'string',
      default: 'success',
      description: (
        <span>
          The contextual style for the background and the demeanor of the robot. One of <code>success</code>,{' '}
          <code>info</code>, <code>warning</code>, or <code>danger</code>.
        </span>
      ),
    },
    {
      name: 'alternate',
      type: 'boolean',
      default: 'false',
      description: 'Uses an alternate robot image, if available. Not all states have alternates.',
    },
  ];

  return (
    <ComponentDoc name="Robot" propInfos={propInfos}>
      <RobotDemo />
      <CodeExample code={RobotCode} />
    </ComponentDoc>
  );
};

export default RobotDocs;
